var pkgDef = {
    tkarta: [{
      "bucketName":"DC1000",
      "type":"data",
      "subType": "1d",
      "oappOnly": false,
      "price": 1,
      "offerBName": "DC1000",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 0,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"DC1000"
      }
    },
    {
      "bucketName":"1D_2GB",
      "type":"data",
      "subType": "1d",
      "oappOnly": false,
      "price": 1.5,
      "offerBName": "1D_2GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 1,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"1D_2GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"1D_2GBVYP"
      }
    },
    {
      "bucketName":"1D_UnLtd",
      "type":"data",
      "subType": "1d",
      "oappOnly": true,
      "price": 2,
      "offerBName": "1D_UnLtd",
      "btnText": "Otvoriť v aplikácii",
      "isChecked": false,
      "paralellDaysAdd": 1,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"1D_UnLtd"
      }
    },
    {
      "bucketName":"10D_UnLtd",
      "type":"data",
      "subType": "10d",
      "oappOnly": false,
      "price": 4,
      "offerBName": "10D_UnLtd",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 10,
      "paralellPack": false,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"10D_UnLtd"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"10D_UnLtdVYP"
      }
    },
    {
      "bucketName":"10D_1GB",
      "type":"data",
      "subType": "10d",
      "oappOnly": false,
      "price": 2,
      "offerBName": "10D_1GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 10,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"10D_1GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"10D_1GBVYP"
      }
    },
    {
      "bucketName":"1000GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 3,
      "offerBName": "1000GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": false,
      "isBenefit": true,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"1000GB"
      }
    },
    {
      "bucketName":"30D_10GBFREE",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 0,
      "offerBName": "30D_10GBFREE",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": false,
      "isBenefit": true,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_10GBFREE"
      }
    },
    {
      "bucketName":"30D_34GBFREE",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 0,
      "offerBName": "30D_34GBFREE",
      "btnText": "Aktivovať",
      "btnAltText": "Obnoviť teraz",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_34GBFREE"
      }
    },
    {
      "bucketName":"30D_1GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 3,
      "offerBName": "30D_1GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_1GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_1GBVYP"
      }
    },
    {
      "bucketName":"30D_3GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 6,
      "offerBName": "30D_3GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_3GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_3GBVYP"
      }
    },
    {
      "bucketName":"30D_4GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 6,
      "offerBName": "30D_4GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_4GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_4GBVYP"
      }
    },
    {
      "bucketName":"30D_5GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 8,
      "offerBName": "30D_5GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_5GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_5GBVYP"
      }
    },
    {
      "bucketName":"30D_6GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 8,
      "offerBName": "30D_6GB",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_6GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_6GBVYP"
      }
    },
    {
      "bucketName":"30D_2GBx",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 8,
      "offerBName": "30D_2GBx",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_2GBx"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_2GBxVYP"
      }
    },
    {
      "bucketName":"30D_6GBx",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 8,
      "offerBName": "30D_6GBx",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_6GBx"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_6GBxVYP"
      }
    },
    {
      "bucketName":"3M_20GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": true,
      "price": 0,
      "offerBName": "3M_20GB",
      "btnText": "Otvoriť v aplikácii",
      "isChecked": false,
      "paralellDaysAdd": 90,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"3M_20GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"3M_20GBVYP"
      }
    },
    {
      "bucketName":"30D_10GBx",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 8,
      "offerBName": "30D_10GBx",
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_10GBx"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_10GBxVYP"
      }
    },
    {
      "bucketName":"Mixi", readable: "MIXI PONUKA", pkgName: "Mixi",
      "type":"top",
      "subType": "7d",
      "oappOnly": false,
      "price": 0,
      "hidePrice": false,
      "offerBName": "Mixi",
      "btnText": "Zobraziť ponuku",
      "isChecked": false,
      "paralellDaysAdd": 7,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateMENU",
        "commandType":""
      },
      "stopProl" : {
        "commandName":"ActivateMENU2",
        "commandType":""
      }
    },
    {
      "bucketName":"FreeCalls2Num",
      "type":"voice",
      "price": 2.5,
      "offerBName": "FreeCalls21N",
      "btnText": "Nastaviť tel. číslo",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "paralellPack": true,
      "isBenefit": false,
      "prolongable": false,
      "start" : {
        "commandName":"FreeCalls21N",
        "commandType":"1"
      },
      "stopProl" : {
        "commandName":"FreeCalls21N",
        "commandType":"0"
      }
    },
    {
      "bucketName":"MIRRI1",
      "type":"data",
      "subType": "1y",
      "oappOnly": false,
      "price": 0,
      "offerBName": "MIRRI1",
      "btnText": "Aktivovať teraz",
      "isChecked": false,
      "paralellDaysAdd": 365,
      "paralellPack": true,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"MIRRI5"
      }
    },
    {
      "bucketName":"MIRRI2",
      "type":"data",
      "subType": "1y",
      "oappOnly": false,
      "price": 0,
      "offerBName": "MIRRI2",
      "btnText": "Aktivovať teraz",
      "isChecked": false,
      "paralellDaysAdd": 365,
      "paralellPack": true,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"MIRRI10"
      }
    }
  ],
  pecka: [
    {
      "bucketName":"DC500", readable: "Denné dáta 1,5 GB",
      "type":"data",
      "price": 1,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"DC500"
      }
    },
    {
      "bucketName":"1D_UnLtd",
      "type":"data",
      "price": 2,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"1D_UnLtd"
      }
    },
    {
      "bucketName": "30D_10GBFREE", readable: "10 GB na 30 dní",
      "type": "data",
      "price": 0,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_10GBFREE"
      }
    },
    {
      "bucketName": "GIGADEN", readable: "Giga Deň",
      "type": "data",
      "price": 1.5,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGADEN"
      }
    },
    {"bucketName": "GIGA1W", readable: "Raz Giga",
      "type": "data",
      "price": 3,
      "prolongable": false,
      "paralellPack": true,
      "paralellDaysAdd": 7,
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"RAZGIGA"
      }
    },
    {
      "bucketName": "GIGA1M", readable: "Vždy Giga",
      "type": "data",
      "price": 6,
      "prolongable": true,
      "paralellPack": true,
      "paralellDaysAdd": 30,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTE500"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA"
      },
      "stopProl" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGAVYP"
      }
    },
    {
      "bucketName": "GIGA2", readable: "Vždy 2 Giga",
      "type": "data",
      "price": 8,
      "prolongable": true,
      "paralellPack": true,
      "paralellDaysAdd": 30,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTE500"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"2GIGA"
      },
      "stopProl" : {
        "commandName":"ActivateGIGA",
        "commandType":"2GIGAVYP"
      }
    },
    {
      "bucketName": "GIGA3", readable: "Vždy Giga (1,5 + 1,5 GB)",
      "type": "data",
      "price": 6,
      "prolongable": true,
      "paralellPack": true,
      "paralellDaysAdd": 30,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTE500"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA3"
      },
      "stopProl" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA3VYP"
      }
    },
    {
      "bucketName": "GIGA5", readable: "Vždy 2 Giga (2,5 + 2,5 GB)",
      "type": "data",
      "price": 8,
      "prolongable": true,
      "paralellPack": true,
      "paralellDaysAdd": 30,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTE500"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA5"
      },
      "stopProl" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA5VYP"
      }
    },
    {
      "bucketName": "Free Voice Onnet", readable: "Neobmedzené Telekom volania",
      "type": "voice",
      "price": 2.79,
      "prolongable": true,
      "skipOrderResponse": true,
      "start" : {
        "commandName":"ActivateFVO",
        "commandType":"1"
      },
      "stopProl" : {
        "commandName":"ActivateFVO",
        "commandType":"2"
      }
    },
    {
      "bucketName": "Free SMS SK", readable: "Neobmedzené SMS",
      "type": "sms",
      "price": 1.59,
      "prolongable": true,
      "skipOrderResponse": true,
      "start" : {
        "commandName":"ActivateFSS",
        "commandType":"1"
      },
      "stopProl" : {
        "commandName":"ActivateFSS",
        "commandType":"2"
      }
    },
    {
      "bucketName": "StreamOn Data Unlmtd", readable: "Stream On",
      "type": "data",
      "price": 1,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateStreamOn",
        "commandType":"1"
      }
    },
    {
      "bucketName": "GIGA6N", readable: "Dáta na rok 6 GB",
      "type": "data",
      "price": 29,
      "prolongable": false,
      "skipOrderResponse": true,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTEGIGA"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA6"
      }
    },
    {
      "bucketName": "GIGA24N", readable: "Dáta na rok 24 GB",
      "type": "data",
      "price": 69,
      "prolongable": false,
      "skipOrderResponse": true,
      "addon" : {
        "commandName":"ActivateGIGA",
        "commandType":"ESTEGIGA"
      },
      "start" : {
        "commandName":"ActivateGIGA",
        "commandType":"GIGA24"
      }
    },
    {
      "bucketName":"Mixi", readable: "MIXI PONUKA", pkgName: "Vždy nový mix dát, volaní a SMS",
      "type":"top",
      "oappOnly": false,
      "price": 0,
      "hidePrice": false,
      "btnText": "Výber balíčka",
      "paralellDaysAdd": 7,
      "isChecked": false,
      "prolongable": false,
      "start" : {
        "commandName":"ActivateMENU",
        "commandType":""
      },
      "stopProl" : {
        "commandName":"ActivateMENU2",
        "commandType":""
      }
    }
  ],
  home:{
    data: {
      "bucketName":"30D_1GB",
      "type":"data",
      "subType": "30d",
      "oappOnly": false,
      "price": 0,
      "btnText": "Aktivovať",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "prolongable": true,
      "start" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_1GB"
      },
      "stopProl" : {
        "commandName":"ActivateTpkg",
        "commandType":"30D_1GBVYP"
      }
    },
    voice: {
      "bucketName":"FreeCalls2Num",
      "type":"voice",
      "price": 0,
      "btnText": "Nastaviť tel. číslo",
      "isChecked": false,
      "paralellDaysAdd": 30,
      "prolongable": false,
      "start" : {
        "commandName":"FreeCalls21N",
        "commandType":"1"
      },
      "stopProl" : {
        "commandName":"FreeCalls21N",
        "commandType":"0"
      }
    },
  },
  travel: [{
    "bucketName": "L24", readable: "5 GB do sveta",
    "type": "none",
    "price": 15.38,
    "paralellDaysAdd": 30,
    "isChecked": false,
    "infoShown": false,
    "start" : {
      "commandName":"ActivateTravel",
      "commandType":"L24"
    },
    "desc": {
      "title": "Objem: 5 GB",
      "valText": "Platnosť: <strong>30 dní</strong>",
      "zoneText": "krajiny Skupiny A"
    }
  },
  {
    "bucketName": "M24", readable: "3 GB do sveta",
    "type": "none",
    "price": 10.25,
    "paralellDaysAdd": 30,
    "isChecked": false,
    "infoShown": false,
    "start" : {
      "commandName":"ActivateTravel",
      "commandType":"M24"
    },
    "desc": {
      "title": "Objem: 3 GB",
      "valText": "Platnosť: <strong>30 dní</strong>",
      "zoneText": "krajiny Skupiny A"
    }
  },
  {
    "bucketName": "S24", readable: "1 GB do sveta",
    "type": "none",
    "price": 5.13,
    "paralellDaysAdd": 7,
    "isChecked": false,
    "infoShown": false,
    "start" : {
      "commandName":"ActivateTravel",
      "commandType":"S24"
    },
    "desc": {
      "title": "Objem: 1 GB",
      "valText": "Platnosť: <strong>7 dní</strong>",
      "zoneText": "krajiny Skupiny A"
    }
  }],
  ares: [{
    "bucketName":"DATA500",
    "type":"data",
    "subType": "1d",
    "oappOnly": false,
    "price": 0.5,
    "offerBName": "DATA500",
    "btnText": "Aktivovať",
    "isChecked": false,
    "paralellDaysAdd": 0,
    "paralellPack": true,
    "prolongable": false,
    "start" : {
      "commandName":"ActivateAres500",
      "commandType":"DATA500"
    }
  }]
}

module.exports = pkgDef;